export const getRandomNumber = (max: number): number => {
  return Math.floor(Math.random() * max);
};
